export const DISCOVERY_WALL_ACTIONS_KEYS = {
  getSectionRecommendations: 'getSectionRecommendations',
  getClicksRecommendations: 'getClicksRecommendations',
  getQueriesRecommendations: 'getQueriesRecommendations',
  getUserRecommendations: 'getUserRecommendations'
} as const;

export const DISCOVERY_WALL_GETTERS_KEYS = {
  sectionRecommendationsRequest: 'sectionRecommendationsRequest',
  clicksRecommendationsRequest: 'clicksRecommendationsRequest',
  queriesRecommendationsRequest: 'queriesRecommendationsRequest',
  userRecommendationsRequest: 'userRecommendationsRequest',
  sectionRecommendations: 'sectionRecommendations',
  clicksRecommendations: 'clicksRecommendations',
  queriesRecommendations: 'queriesRecommendations',
  userRecommendations: 'userRecommendations',
  sectionShowTracking: 'sectionShowTracking',
  clicksShowTracking: 'clicksShowTracking',
  queriesShowTracking: 'queriesShowTracking',
  userShowTracking: 'userShowTracking'
} as const;

export const DISCOVERY_WALL_MUTATIONS_KEYS = {
  resetDiscoveryWallState: 'resetDiscoveryWallState',
  setDiscoveryWallLoading: 'setDiscoveryWallLoading',
  setDiscoveryWallState: 'setDiscoveryWallState'
} as const;
